var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddnoteinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0208 16.0417H11.9791V13.2917H14.8541V12.375H11.9791V9.625H11.0208V12.375H8.14579V13.2917H11.0208V16.0417ZM4.79163 19.25V2.75H13.8958L18.2083 6.875V19.25H4.79163ZM13.4166 7.33333H17.25L13.4166 3.66667V7.33333Z",
    fill: "#E17954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddnoteinfo);
export default __webpack_public_path__ + "static/media/addnoteinfo.a9f0fbc309481bb636549baf4cd7f4be.svg";
export { ForwardRef as ReactComponent };